import React from "react";
import ClientCell from "./ClientCell";
import ClientLabel from "./ClientLabel";
import { InfoBubbleInputWrapper } from "./InfoBubbleWrappers";

// If a fieldKey is specified, shows an InfoBubble with information text
const ClientRow = ({ clientModels, label, renderCell, fieldKey = null, maxWidth = null, cellClassName = "" }) => {

    return <>
        {label && <ClientLabel>
            {label}
        </ClientLabel>}
        <React.Fragment>
            {clientModels?.map((client, index) => (
                fieldKey != null && index === 0
                    ? (
                        <ClientCell key={client.clientAccountId} className={cellClassName} index={index} maxWidth={maxWidth} isUsingWrapper>
                            <InfoBubbleInputWrapper iconClassName="mt-2" fieldKey={fieldKey} showBubble={index === 0 && fieldKey}>
                                {renderCell(client, index)}
                            </InfoBubbleInputWrapper>
                        </ClientCell>
                    )
                    : (
                        <ClientCell className={cellClassName} key={client.clientAccountId} index={index} maxWidth={maxWidth}>
                            {renderCell(client, index)}
                        </ClientCell>
                    )
            ))}
        </React.Fragment>
    </>
}

export default ClientRow;